import { render } from "./index.vue?vue&type=template&id=3c53a2a8&scoped=true"
const script = {}

import "./index.vue?vue&type=style&index=0&id=3c53a2a8&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c53a2a8"]])

export default __exports__